import styled from 'styled-components'

export const LayoutContainer = styled.div`
    height: 100vh;
    box-sizing: border-box;
`



// WEBPACK FOOTER //
// ./src/styledComponents/LayoutContainer/LayoutContainer.js